import { useMemo } from "react";
import { getTimeZones } from "@vvo/tzdb";

/**
 * Returnerar Europe/* tidszoner.
 * Sätt onlyCET=false om du vill alla europeiska zoner (inte bara Central European).
 */
export function useTimeZones(onlyCET = false) {
  return useMemo(() => {
    const tz = getTimeZones();
    let list = tz.filter(z => z?.name?.startsWith("Europe/"));

    if (onlyCET) {
      list = list.filter(z => /central european/i.test(z?.alternativeName ?? ""));
    }

    // Unika + sorterade namn
    return [...new Set(list.map(z => z.name))].sort((a, b) => a.localeCompare(b));
  }, [onlyCET]);
}